<ng-template #faqTemplateHeader>
  <a routerLink="/notes-de-version">Accéder aux notes de versions</a>
</ng-template>
<ng-template #faqTemplateContent>
  @for (version of latestVersions; track version) {
    <a
      [title]="version.name | urldecode"
      class="content-grid p-3"
      [routerLink]="['/notes-de-version', version.category.name, getMinorVersion(version.name)]">
      <div>Notes de version {{version.category.name}} {{ version.name | urldecode }}</div>
      <div>
        <span style="display: contents">
          @if (version.category; as c) {
            <app-badge class="me-1 ms-1"
              [label]="{id: 0, textcolor: c.textcolor, backcolor: c.backcolor, name: c.name}">
            </app-badge>
          }
        </span>
      </div>
    </a>
  }
</ng-template>
@if(hasRn) {
  <app-dash-block title="Notes de versions" [error]="error"
    [contentTemplate]="latestVersions ? faqTemplateContent : null">
  </app-dash-block>
}
